export const FCRA_STATUS = {
  REGISTERED: 'registered',
  NOT_REGISTERED: 'not_registered'
} as const

export type FcraStatus = typeof FCRA_STATUS[keyof typeof FCRA_STATUS]
